export const PLATFORM_FILTER_PARAMETER = { platform: { $containsi: '"web"' } };
